<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import Intersect from 'vue-intersect';
import anime from 'animejs/lib/anime.es.js';

export default {
  mixins: [fandomBasicMixin],
  components: {
    Intersect
  },
  data() {
    return {
      iconWidth: null,
      screenWidth: null,
      deltaY: 200, // pixel
      visible: false,
      enterTimer: null,
      leaveTimer: null,
      rotateAnimation: null,
      intersectEntered: false
    }
  },
  mounted() {
    this.screenWidth = window.innerWidth;
  },
  methods: {
    randomNumber(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    iconStyle() {
      const style = [{ 'background-image': `url(${this.content.icon.url})` }]
      if (this.iconWidth && this.screenWidth) {
        const xPos = this.randomNumber(0, this.screenWidth - this.iconWidth);
        const yPos = this.randomNumber(-this.deltaY, this.deltaY);
        style.push({ 'translate': `${xPos}px ${yPos}px` });
      }
      return style;
    },
    enterIntersect() {
      this.intersectEntered = true;
      if (this.leaveTimer) {
        window.clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      } else {
        this.enterTimer = setTimeout(() => {
          if (this.enterTimer) {
            this.visible = true;
            Vue.nextTick(() => {
              this.iconWidth = this.$refs.icon.offsetWidth;
            })
            anime({
              targets: this.$refs.icon,
              scale: [2, 1],
              opacity: [0, 1],
              translateY: ['-50%', '-50%'],
              easing: 'easeInQuad',
              duration: 200,
              complete: () => {
                this.rotateAnimation = anime({
                  targets: this.$refs.icon,
                  rotate: ['-25deg', '25deg'],
                  easing: 'linear',
                  duration: 12000,
                  direction: 'alternate',
                  loop: true
                });
              }
            });
          }
        }, this.content.delay_time || 500);
      }
    },
    leaveIntersect() {
      if (this.intersectEntered) {
        this.intersectEntered = false;
        this.leaveTimer = setTimeout(() => {
          anime({
            targets: this.$refs.icon,
            opacity: [1, 0],
            easing: 'linear',
            duration: 200,
            complete: () => {
              this.leaveTimer = null;
              this.enterTimer = null;
              this.visible = false;
              if (this.rotateAnimation) {
                this.rotateAnimation.pause();
                this.rotateAnimation = null;
              }
            }
          });
        }, 5000);
      }
    },
    pauseAnimation(animation) {
      if (animation) {
        animation.pause();
      }
    },
    playAnimation(animation) {
      if (animation) {
        animation.play();
      }
    }
  }
};
</script>

<template>
  <div v-if="content.url && content.icon.url" v-easyadmin="easyadminId" stripe-sticker-component>
    <intersect @enter="enterIntersect" @leave="leaveIntersect">
      <div class="position-relative">
        <a
          ref="icon"
          v-show="visible"
          :href="content.url.url"
          :target="getTarget(content.url)"
          :title="content.url.title"
          class="icon position-absolute cursor-pointer"
          :style="iconStyle()"
          @mouseenter="pauseAnimation(rotateAnimation)"
          @mouseleave="playAnimation(rotateAnimation)"
        ></a>
      </div>
    </intersect>
  </div>
</template>

<style lang="scss">
[stripe-sticker-component] {

  .icon {
    width: 13rem;
    height: 13rem;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transform: translateY(-50%) rotate(-25deg);
    filter: drop-shadow(0 0 0.75rem rgba(0,0,0,0.25));
    z-index: 1000;

    @include media-breakpoint-down(md) {
      width: 10rem;
      height: 10rem;
    }
  }
  
}
</style>